import { useMemo } from 'react';

import { useSearchParams } from 'react-router-dom';

const defaultSearchData = {
  leadNumber: '',
  businessType: '',
  fullName: '',
  companyName: '',
  communicationMethod: '',
  page: 1,
  limit: 10,
  createdDateFrom: '',
  createdDateTo: '',
  workflowStatusId: '',
  status: '',
  leadSourceId: '',
  createdByUuid: '',
  assigneeUuid: '',
  withAppointment: '',
  type: '',
};

export const useLeadsPoolSearchData = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getString = (key) => searchParams.get(key) ?? '';
  const getNumber = (key, fallback) => {
    const val = searchParams.get(key);
    return val !== null ? Number(val) : fallback;
  };

  const searchData = useMemo(
    () => ({
      leadNumber: getString('leadNumber'),
      businessType: getString('businessType'),
      fullName: getString('fullName'),
      companyName: getString('companyName'),
      communicationMethod: getString('communicationMethod'),
      page: getNumber('page', defaultSearchData.page),
      limit: getNumber('limit', defaultSearchData.limit),
      createdDateFrom: getString('createdDateFrom'),
      createdDateTo: getString('createdDateTo'),
      workflowStatusId: getString('workflowStatusId'),
      status: getString('status'),
      leadSourceId: getString('leadSourceId'),
      createdByUuid: getString('createdByUuid'),
      assigneeUuid: getString('assigneeUuid'),
      withAppointment: getString('withAppointment'),
      type: getString('type'),
    }),
    [searchParams]
  );

  const setLeadsPoolSearchData = (updated) => {
    const nextParams = new URLSearchParams();
    const fullSearchData = { ...searchData, ...updated };

    if (!(Object.keys(updated).length === 1 && 'page' in updated)) {
      fullSearchData.page = 1;
    }

    Object.entries(fullSearchData).forEach(([key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        nextParams.set(key, value);
      }
    });

    setSearchParams(nextParams, { replace: true });
  };

  const resetSearchData = () => {
    const nextParams = new URLSearchParams();
    Object.entries(defaultSearchData).forEach(([key, value]) => {
      if (value !== '') {
        nextParams.set(key, value);
      }
    });
    setSearchParams(nextParams, { replace: true });
  };

  return {
    searchData,
    setLeadsPoolSearchData,
    resetSearchData,
    defaultSearchData,
  };
};
